import React, { Component } from 'react';
import Layout from '../layout';
import HardwareHero from '../assets/v2/png/HardwareHero.png';
import PartnerFeatures from '../components/Esper/PartnerPage/PartnerFeatures';
import GrowAudience from '../components/Esper/PartnerPage/GrowAudience';
import InterestedNext from '../components/Esper/PartnerPage/InterestedNext';
import PartnerWhatEsperBrings from '../components/Esper/PartnerPage/PartnerWhatEsperBrings';

import PartnerPricing from '../components/Esper/PartnerPage/PartnerPricing';
import AndroidSolutions from '../components/Esper/PartnerPage/AndroidSolutions';
import HardwareCarousel from '../components/Esper/Hardware/HardwareCarousel';
import HowToPartner from '../components/Esper/PartnerPage/HowToPartner';
import AndroidOEMs from '../components/Esper/PartnerPage/AndroidOEMs';
import PartnerSectionTwo from '../components/Esper/PartnerPage/PartnerSectionTwo';
import HeaderAnimation from '../components/Esper/PartnerPage/HeaderAnimation';
import messages from '../i18n/en';

export default class Hardware extends Component<any, any> {
  render() {
    return (
      <Layout
        ogImage={HardwareHero}
        messages={messages}
        title={'Join Esper’s Ecosystem of Android Partnerships | Esper Partner'}
        description={`Grow Your Android Markets with Esper. We’re creating an ecosystem of Android solutions providers for open collaboration.`}
        keywords={`Esper partners, MDM partner, DevOps partner, Esper ecosystem, Esper OEM`}
        className="first-page"
        location={this.props.location}
      >
        {/* <HardwareSectionOne /> */}
        {/* <HardwareSectionTwo /> */}
        <HeaderAnimation />

        <PartnerFeatures />
        <GrowAudience />
        <HardwareCarousel partnerPage={true} />
        <HowToPartner />
        <InterestedNext />
        <div
          style={{
            display: 'grid',
            justifyItems: 'center',
            width: '100% !important',
          }}
        >
          <div
            style={{
              borderBottom: '1px solid #aeb2be',
              width: '75%',
              height: '1px',
              // maxWidth:'1024px'
              // padding: '2rem 0rem',
            }}
          />
        </div>

        <AndroidOEMs />
        <div
          style={{
            display: 'grid',
            justifyItems: 'center',
            width: '100% !important',
          }}
        >
          <div
            style={{
              borderBottom: '1px solid #aeb2be',
              width: '75%',
              height: '1px',
              // maxWidth:'1024px'
              // padding: '2rem 0rem',
            }}
          />
        </div>

        <PartnerSectionTwo />
        <div
          style={{
            display: 'grid',
            justifyItems: 'center',
            width: '100% !important',
          }}
        >
          <div
            style={{
              borderBottom: '1px solid #aeb2be',
              width: '75%',
              height: '1px',
              // maxWidth:'1024px'
              // padding: '2rem 0rem',
            }}
          />
        </div>

        <AndroidSolutions />

        {/* <HardwareSectionFive /> */}
        {/* <HardwareSectionFour /> */}
        {/* <OurPartners
          companies={['lenovo', 'zebra', 'mediatek']}
          title={`You’re in good company, Our Partners `}
        /> */}
        {/* <BottomBanner
          description={`Scale and deploy your Android devices
          on the field like never before!`}
          buttonText={`Start your free trial `}
          link="https://esper.io/signup"
        /> */}
        <PartnerWhatEsperBrings />
        <PartnerPricing messages={messages} />
      </Layout>
    );
  }
}
